export const setList = (state, payload) => state.list = payload;
export const setYears = (state, payload) => state.years = payload;